export const permissionOptions = [
  { topCard: "People", name: 'people', options: ["Read", "Write", "None"] },
  { topCard: "Pensions", name: 'pensions', exclude: ['MT'], options: ["Read", "Write", "None"] },
  { topCard: "Grades", name: 'grades', options: ["Read", "Write", "None"] },
  { topCard: "Payroll", name: 'payroll', options: ["Read", "Write", "None"] },
  { topCard: "Tax Forms", name: 'taxForms', options: ["Read", "Write", "None"] },
  { topCard: "Reports", name: 'reports', options: ["Read", "Write", "None"] },
  { topCard: "Assets", name: 'assets', exclude: ['MT'], options: ["Read", "Write", "None"] },
  { topCard: "Timesheets", name: 'timesheets', options: ["Read", "Write", "None"] },
  { topCard: "Leave", name: 'leave', options: ["Read", "Write", "None"] },
  { topCard: "Work Locations", name: 'workLocations', options: ["Read", "Write", "None"] },
  { topCard: "Accounting", name: 'accounting', exclude: ['MT'], options: ["Read", "Write", "None"] },
  { topCard: "Settings", name: 'settings', options: ["Read", "Write", "None"] },
  { topCard: "Permissions", name: 'permissions', options: ["Read", "Write", "None"] },
  { topCard: "MFA Status", name: 'mfa', options: ["Read", "Write", "None"] },
  { topCard: "Billing", name: 'billing', options: ["Read", "Write", "None"] },
]